import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, thriweDiscoveryUrl } from '../../../../../../Containers/Config/index.js';
import { GET_SURGE_FILE_LIST, GET_SURGE_FILE_LIST_SUCCESS, GET_SURGE_FILE_LIST_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* getFileList({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };

    const response = yield call(apiCall, {
      url: `${thriweDiscoveryUrl}/v1/admin/data-integration/file-uploads`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: GET_SURGE_FILE_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: GET_SURGE_FILE_LIST_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_SURGE_FILE_LIST_ERROR, payload: error });
  }
}

export function* watchgetFileList() {
  yield takeEvery(GET_SURGE_FILE_LIST, getFileList);
}

function* getFileListSaga() {
  yield all([fork(watchgetFileList)]);
}

export default getFileListSaga;
